/**
 * The Indian financial year, as a starting year.
 *
 * April to March. 2026 covers 2026-04-01 … 2027-03-31 and prints "2026-27".
 * The invoice series restarts each one, which is why this is a shared helper
 * rather than a line inline somewhere: the number, the storage key and any
 * later GSTR export all have to agree on which year a document belongs to.
 */
export function financialYearOf(date: Date): number {
  // getMonth() is zero-based, so 3 is April.
  return date.getMonth() >= 3 ? date.getFullYear() : date.getFullYear() - 1;
}

/** "2026-27" — how the year is printed on the document and in the key. */
export function financialYearLabel(startYear: number): string {
  const end = (startYear + 1) % 100;
  return `${startYear}-${String(end).padStart(2, '0')}`;
}
